import { render, staticRenderFns } from "./DetailBomList.vue?vue&type=template&id=c21cdd1c"
import script from "./DetailBomList.vue?vue&type=script&lang=js"
export * from "./DetailBomList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports